export default __webpack_public_path__ + "static/media/filters.0ca10fd9.svg";